<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 text--base offset-sm-1 offset-md-2">
        <SurveyImpact :title="impactTitle" />
      </div>
    </div>
  </div>
</template>

<script>
import { json as fetchJson } from 'd3';
import SurveyImpact from '@/components/content/chapter2/SurveyImpact.vue';

export default {
  name: 'App4ColumnChart',
  components: {
    SurveyImpact,
  },
  data() {
    return {
      content: {},
    };
  },
  computed: {
    impactTitle() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'survey-impact').title : '';
    },
  },
  async created() {
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-02.json`);
  }
};
</script>

<style scoped>
.container {
  background-color: #f8f7f5;
}
</style>
